//# sourceMappingURL=toastify.mjs.map
/// <reference types="./toastify.d.mts" />
import * as $option from "../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../redraw/redraw.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";
import * as $options from "./redraw_toastify/internal/options.mjs";
import { container as toast_container } from "./toastify.ffi.mjs";
import * as $toast from "./toastify/toast.mjs";

export { toast_container };

class Props extends $CustomType {
  constructor(position, auto_close, close_button, transition, hide_progress_bar, pause_on_hover, pause_on_focus_loss, rtl, stacked, close_on_click, newest_on_top, class_name, style, toast_class_name, progress_class_name, draggable, draggable_percent, draggable_direction, container_id, limit, role, theme) {
    super();
    this.position = position;
    this.auto_close = auto_close;
    this.close_button = close_button;
    this.transition = transition;
    this.hide_progress_bar = hide_progress_bar;
    this.pause_on_hover = pause_on_hover;
    this.pause_on_focus_loss = pause_on_focus_loss;
    this.rtl = rtl;
    this.stacked = stacked;
    this.close_on_click = close_on_click;
    this.newest_on_top = newest_on_top;
    this.class_name = class_name;
    this.style = style;
    this.toast_class_name = toast_class_name;
    this.progress_class_name = progress_class_name;
    this.draggable = draggable;
    this.draggable_percent = draggable_percent;
    this.draggable_direction = draggable_direction;
    this.container_id = container_id;
    this.limit = limit;
    this.role = role;
    this.theme = theme;
  }
}

/**
 * Creates the default props used by toastify.
 */
export function props() {
  return new Props(
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
}

export function position(props, position) {
  let position$1 = new Some(position);
  return new Props(
    position$1,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Toasts will autoclose themselves after 5 seconds. \
 * Default toasts autoclose after 5 seconds.
 */
export function auto_close(props) {
  let auto_close$1 = new Some(new $options.AutocloseBool(true));
  return new Props(
    props.position,
    auto_close$1,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Toasts will autoclose themselves atfer `timeout` milliseconds. \
 * Default toasts autoclose after 5 seconds.
 */
export function auto_close_after(props, timeout) {
  let auto_close$1 = new Some(new $options.AutocloseTimeout(timeout));
  return new Props(
    props.position,
    auto_close$1,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Toasts will never autoclose, and have to be closed manually. \
 * Default toasts autoclose after 5 seconds.
 */
export function close_manually(props) {
  let auto_close$1 = new Some(new $options.AutocloseBool(false));
  return new Props(
    props.position,
    auto_close$1,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Hide the default close button. \
 * Displayed by default.
 */
export function hide_close_button(props) {
  let close_button = new Some(new $options.CloseButtonBool(false));
  return new Props(
    props.position,
    props.auto_close,
    close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Show the default close button. \
 * Displayed by default.
 */
export function show_close_button(props) {
  let close_button = new Some(new $options.CloseButtonBool(true));
  return new Props(
    props.position,
    props.auto_close,
    close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Customise the close button. The close button should be a valid React component. \
 * Displayed by default.
 */
export function custom_close_button(props, component) {
  let close_button = new Some(new $options.CloseButtonNode(component));
  return new Props(
    props.position,
    props.auto_close,
    close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * A reference to a valid `react-transition-group/Transition` component. \
 * `Bounce` by default.
 */
export function transition(props, transition) {
  let transition$1 = new Some(transition);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    transition$1,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Display or not the progress bar belowe the time,
 * indicating the remaining time. \
 * Visible by default.
 */
export function hide_progress_bar(props, hide_progress_bar) {
  let hide_progress_bar$1 = new Some(hide_progress_bar);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    hide_progress_bar$1,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Keep the timer running or not on hover. \
 * `True` by default.
 */
export function pause_on_hover(props, pause_on_hover) {
  let pause_on_hover$1 = new Some(pause_on_hover);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    pause_on_hover$1,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Pause the timer when the window loses focus. \
 * `True` by default.
 */
export function pause_on_focus_loss(props, pause_on_focus_loss) {
  let pause_on_focus_loss$1 = new Some(pause_on_focus_loss);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    pause_on_focus_loss$1,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Support right to left content. \
 * `False` by default.
 */
export function rtl(props, rtl) {
  let rtl$1 = new Some(rtl);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    rtl$1,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Stack notifications. \
 * `False` by default.
 */
export function stacked(props, stacked) {
  let stacked$1 = new Some(stacked);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    stacked$1,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Dismiss toast on click. \
 * `False` by default.
 */
export function close_on_click(props, close_on_click) {
  let close_on_click$1 = new Some(close_on_click);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    close_on_click$1,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Display newest toast on top. \
 * `False` by default.
 */
export function newest_on_top(props, newest_on_top) {
  let newest_on_top$1 = new Some(newest_on_top);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    newest_on_top$1,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Add optional classes to the container.
 */
export function class_name(props, class_name) {
  let class_name$1 = new Some(class_name);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    class_name$1,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Add optional inline style to the container.
 */
export function style(props, style) {
  let style$1 = new Some(style);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    style$1,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Add optional classes to the toast.
 */
export function toast_class_name(props, toast_class_name) {
  let toast_class_name$1 = new Some(toast_class_name);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    toast_class_name$1,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Add optional classes to the progress bar.
 */
export function progress_class_name(props, progress_class_name) {
  let progress_class_name$1 = new Some(progress_class_name);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    progress_class_name$1,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Allow toast to be draggable. \
 * `True` by default.
 */
export function draggable(props, draggable) {
  let draggable$1 = new Some(draggable);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    draggable$1,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * The percentage of the toast's width it takes for a drag to dismiss a
 * toast (value between 0 and 100). \
 * `80` by default.
 */
export function draggable_percent(props, draggable_percent) {
  let draggable_percent$1 = new Some(draggable_percent);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    draggable_percent$1,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Specify the drag direction. \
 * `draggable_x` by default.
 */
export function draggable_x(props) {
  let draggable_direction = new Some(new $options.DraggableDirection("x"));
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Specify the drag direction. \
 * `draggable_x` by default.
 */
export function draggable_y(props) {
  let draggable_direction = new Some(new $options.DraggableDirection("y"));
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Used to identify the `toast_container` when working with multiple containers.
 * Also used to set the `id` attribute.
 */
export function container_id(props, container_id) {
  let container_id$1 = new Some(container_id);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    container_id$1,
    props.limit,
    props.role,
    props.theme,
  );
}

/**
 * Used to limit the number of toast displayed on screen at the same time.
 */
export function limit(props, limit) {
  let limit$1 = new Some(limit);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    limit$1,
    props.role,
    props.theme,
  );
}

/**
 * Define the ARIA role for the toasts.
 */
export function role(props, role) {
  let role$1 = new Some(role);
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    role$1,
    props.theme,
  );
}

/**
 * Define the theme to `light`. \
 * `light_theme` by deafult.
 */
export function light_theme(props) {
  let theme = new Some(new $options.Theme("light"));
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    theme,
  );
}

/**
 * Define the theme to `light`. \
 * `light_theme` by deafult.
 */
export function dark_theme(props) {
  let theme = new Some(new $options.Theme("dark"));
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    theme,
  );
}

/**
 * Define the theme to `colored`. \
 * `light_theme` by deafult.
 */
export function colored_theme(props) {
  let theme = new Some(new $options.Theme("colored"));
  return new Props(
    props.position,
    props.auto_close,
    props.close_button,
    props.transition,
    props.hide_progress_bar,
    props.pause_on_hover,
    props.pause_on_focus_loss,
    props.rtl,
    props.stacked,
    props.close_on_click,
    props.newest_on_top,
    props.class_name,
    props.style,
    props.toast_class_name,
    props.progress_class_name,
    props.draggable,
    props.draggable_percent,
    props.draggable_direction,
    props.container_id,
    props.limit,
    props.role,
    theme,
  );
}
